// extracted by mini-css-extract-plugin
export default {"container":"CharacterNameSelector_container__KedYK","heroName":"CharacterNameSelector_heroName__DtUmw"};